import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const DropdownMenuItemsWrapper = styled.div<{ active?: boolean }>`
  background-color: ${({ active }) => (active ? '#03323F' : 'transparent')};
  border-radius: ${tokens.radius.large};
  padding: ${tokens.spacing.insetXsmall};
  display: flex;
  flex-direction: column;
  transition: ${tokens.transitions.motionSlow1},
    max-height ${tokens.transitions.motionSlow1};
  max-height: ${({ active }) => (active ? '400px' : '56px')};
  user-select: none;
`

export const DropdownHeaderWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: ${tokens.spacing.insetXsmall} ${tokens.spacing.insetSmall};
  position: relative;
`

export const DropdownHeaderText = styled.p`
  font-size: ${tokens.fontSize.medium};
  font-weight: ${tokens.fontWeights.bold};
  margin: 0;
  padding: ${tokens.spacing.insetXxsmall} ${tokens.spacing.insetSmall};
  color: ${tokens.colors.dark0};
  line-height: ${tokens.lineHeight.large}%;
`

export const WrapperCaretIcon = styled.div`
  position: absolute;
  right: ${tokens.spacing.insetSmall};
`

export const DropdownListWrapper = styled.div<{
  isDropdownActive?: boolean
}>`
  margin-top: 2px;
  transition: ${tokens.transitions.motionSlow1};
  opacity: ${({ isDropdownActive }) => (isDropdownActive ? 1 : 0)};
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
`

export const DropdownItem = styled.div<{ isCurrentPath?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: ${tokens.radius.large};
  background-color: ${({ isCurrentPath }) =>
    isCurrentPath ? tokens.colors.dark5 : 'transparent'};

  &:hover {
    background-color: ${tokens.colors.dark5};
    transition: ${tokens.transitions.motionSlow1};
  }
`

export const DropdownTextItem = styled.p`
  font-size: ${tokens.fontSize.medium};
  line-height: ${tokens.lineHeight.medium}%;
  font-weight: ${tokens.fontWeights.regular};
  color: ${tokens.colors.dark0};
  margin: 0px;
  padding: ${tokens.spacing.insetXsmall} ${tokens.spacing.insetMedium};
  width: 100%;
`
